export const gradientFull = [
  { offset: '5%', color: '#8c96a2' },
  { offset: '100%', color: '#667778' },
]
export const gradientAlert = [
  { offset: '5%', color: '#ff8a00' },
  { offset: '100%', color: '#ffc627' },
]
export const gradientOk = [
  { offset: '5%', color: '#398712' },
  { offset: '100%', color: '#22c00e' },
]
export const gradientFullCss =
  'linear-gradient(90deg, rgb(140, 150, 162) 0%, rgb(102, 103, 120) 100%);'

export const gradientAlertCss =
  'linear-gradient(90deg, rgb(255, 138, 0) 0%, rgb(255, 138, 0), rgb(255, 198, 39), rgb(255, 198, 39) 100%);'
export const gradientOkCss =
  'linear-gradient(90deg, rgb(57, 135, 18) 0%, rgb(57, 135, 18), rgb(34, 192, 14), rgb(34, 192, 14) 100%);'

export const getGradientType = (proportion, css) => {
  if (proportion >= 0.99) return css ? gradientFullCss : gradientFull
  if (proportion >= 0.74) return css ? gradientAlertCss : gradientAlert
  return css ? gradientOkCss : gradientOk
}
